import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import "./index.css";
import 'animate.css';

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.js";
import {
  //BrowserRouter,
  Route,
  RouterProvider,
  //Routes,
  createBrowserRouter,
  createRoutesFromElements,
} from "react-router-dom";
import { ThemeProvider } from "./contexts/ThemeContext";
//import AuthContext, { AuthProvider } from "./context/AuthContext.js";

/*ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)*/

//static router - see: https://reactrouter.com/en/6.22.3/routers/picking-a-router
/*ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/*" element={<App />}></Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);*/

//new data router API
const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/*" element={<App />} />
  ),
  {
    // Add basename if your app is served from a subdirectory
    // basename: "/subdirectory"
  }
);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ThemeProvider>
      <RouterProvider router={router} fallbackElement={<Fallback />} />
    </ThemeProvider>
  </React.StrictMode>
);

export function Fallback() {
  return <p>Performing initial data load</p>;
}
